(function () {
  function q(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function findMedia(wrapper) {
    return wrapper ? wrapper.querySelector('video, iframe') : null;
  }

  function ensureControls(videoElement) {
    const media = findMedia(videoElement);
    if (!media) return;
    if (media.tagName === 'VIDEO') {
      media.setAttribute('controls', '');
      media.removeAttribute('muted');
      media.muted = false;
      media.volume = 1;
    } else if (media.tagName === 'IFRAME') {
      try {
        const url = new URL(media.src, window.location.origin);
        if (/youtube\.com\/embed/.test(url.href)) {
          url.searchParams.set('enablejsapi', '1');
          url.searchParams.set('playsinline', '1');
          url.searchParams.set('controls', '1');
          url.searchParams.set('mute', '0');
          media.src = url.toString();
        } else if (/player\.vimeo\.com\/video/.test(url.href)) {
          url.searchParams.set('background', '0');
          url.searchParams.set('muted', '0');
          media.src = url.toString();
        }
      } catch (e) {}
    }
  }

  function hydrateIfNeeded(videoElement) {
    if (!videoElement) return;
    if (!findMedia(videoElement)) {
      const tpl = q(videoElement, 'template');
      if (tpl && 'content' in tpl) {
        const clone = tpl.content.cloneNode(true);
        videoElement.appendChild(clone);
      }
    }
    if (!videoElement.hasAttribute('loaded')) {
      videoElement.setAttribute('loaded', '');
    }
    ensureControls(videoElement);
  }

  function playIframeWithSound(iframe) {
    try {
      const url = new URL(iframe.src, window.location.origin);
      if (/youtube\.com\/embed/.test(url.href)) {
        url.searchParams.set('enablejsapi', '1');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('controls', '1');
        url.searchParams.set('mute', '0');
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: [] }), '*');
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
      } else if (/player\.vimeo\.com\/video/.test(url.href)) {
        url.searchParams.set('background', '0');
        url.searchParams.set('muted', '0');
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
        iframe.contentWindow?.postMessage({ method: 'setVolume', value: 1 }, '*');
        iframe.contentWindow?.postMessage({ method: 'play' }, '*');
      } else {
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
      }
    } catch (e) {}
  }

  function playMedia(videoElement) {
    const media = findMedia(videoElement);
    if (!media) return false;
    if (media.tagName === 'VIDEO') {
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('controls', '');
      media.removeAttribute('muted');
      media.muted = false;
      media.volume = 1;
      const p = media.play();
      if (p && typeof p.catch === 'function') p.catch(() => setTimeout(() => media.play().catch(() => {}), 60));
      return true;
    } else if (media.tagName === 'IFRAME') {
      playIframeWithSound(media);
      return true;
    }
    return false;
  }

  function pauseIframe(iframe) {
    try {
      if (/youtube\.com\/embed/.test(iframe.src)) {
        iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      } else if (/player\.vimeo\.com\/video/.test(iframe.src)) {
        iframe.contentWindow?.postMessage({ method: 'pause' }, '*');
      } else {
        const url = new URL(iframe.src, window.location.origin);
        url.searchParams.set('autoplay', '0');
        iframe.src = url.toString();
      }
    } catch (e) {}
  }

  function pauseMedia(videoElement) {
    const media = findMedia(videoElement);
    if (!media) return false;
    if (media.tagName === 'VIDEO') {
      media.pause();
      return true;
    } else if (media.tagName === 'IFRAME') {
      pauseIframe(media);
      return true;
    }
    return false;
  }

  function neutralizeHoverRuntime() {
    const Existing = customElements.get('stf-card');
    if (Existing) {
      if (Existing.prototype.handleMouseInteraction) Existing.prototype.handleMouseInteraction = function () {};
      if (Existing.prototype._hover) Existing.prototype._hover = function () {};
    }
    const cards = document.querySelectorAll('stf-card');
    cards.forEach((c) => c.classList.remove('is-hovering'));
    const mo = new MutationObserver((muts) => {
      muts.forEach((m) => {
        if (m.type === 'attributes' && m.target.tagName === 'STF-CARD') {
          if (m.target.classList.contains('is-hovering')) m.target.classList.remove('is-hovering');
        }
      });
    });
    cards.forEach((c) => mo.observe(c, { attributes: true, attributeFilter: ['class'] }));
    const ro = new MutationObserver((muts) => {
      muts.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1 && n.tagName === 'STF-CARD') {
            n.classList.remove('is-hovering');
            mo.observe(n, { attributes: true, attributeFilter: ['class'] });
          }
        });
      });
    });
    ro.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (!customElements.get('stf-card')) {
    customElements.define(
      'stf-card',
      class STFCard extends HTMLElement {
        constructor() { super(); }
        get videoElement() { return q(this, 'video-element'); }
        connectedCallback() {}
        disconnectedCallback() {}
      }
    );
  } else {
    neutralizeHoverRuntime();
  }

  if (!customElements.get('shop-the-feed')) {
    customElements.define(
      'shop-the-feed',
      class ShopTheFeed extends HTMLElement {
        constructor() { super(); }
        connectedCallback() {
          this.selectors = { sliderWrapper: '.shop-the-feed__items', nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev', pagination: '.swiper-pagination' };
          this.classes = { grid: 'f-grid', swiper: 'swiper', swiperWrapper: 'swiper-wrapper' };
          this.sectionId = this.dataset.sectionId;
          this.section = this.closest(`.section-${this.sectionId}`);
          this.sliderWrapper = q(this, this.selectors.sliderWrapper);
          this.enableSlider = this.dataset.enableSlider === 'true';
          this.items = parseInt(this.dataset.items);
          this.laptopItems = parseInt(this.dataset.laptopItems);
          this.tabletItems = parseInt(this.dataset.tabletItems);
          this.paginationType = this.dataset.paginationType || 'bullets';
          this.sliderInstance = false;
          if (!this.enableSlider) return;
          const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          mql.onchange = this.init.bind(this);
          this.init();
        }
        init() {
          if (FoxTheme.config.mqlMobile) { this.destroySlider(); } else { this.initSlider(); }
        }
        initSlider() {
          if (typeof this.sliderInstance === 'object') return;
          const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
          const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
          this.sliderOptions = {
            slidesPerView: 2,
            spaceBetween: spaceBetween,
            navigation: { nextEl: this.section.querySelector(this.selectors.nextEl), prevEl: this.section.querySelector(this.selectors.prevEl) },
            pagination: { el: this.section.querySelector(this.selectors.pagination), type: this.paginationType },
            breakpoints: { 768: { slidesPerView: this.tabletItems > 3 ? 3 : this.tabletItems }, 1024: { slidesPerView: this.laptopItems }, 1280: { slidesPerView: this.items } },
            loop: false,
            threshold: 2,
            watchSlidesProgress: true,
            mousewheel: { enabled: true, forceToAxis: true }
          };
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.grid);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();
          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
          focusableElements.forEach((el) => {
            el.addEventListener('focusin', () => {
              const slide = el.closest('.swiper-slide');
              this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            });
          });
          if (Shopify.designMode && typeof this.sliderInstance === 'object') {
            document.addEventListener('shopify:block:select', (e) => {
              if (e.detail.sectionId != this.sectionId) return;
              const { target } = e;
              const index = Number(target.dataset.index);
              this.sliderInstance.slider.slideTo(index);
            });
          }
        }
        destroySlider() {
          this.classList.remove(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper.classList.add(this.classes.grid);
          if (typeof this.sliderInstance !== 'object') return;
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    );
  }

  document.addEventListener('click', function (e) {
    const card = e.target.closest('stf-card');
    if (!card) return;
    if (e.target.closest('.stf-card__footer')) return;
    if (e.target.closest('a, button, .btn, input, textarea, select, label')) return;
    if (e.target.closest('.swiper-button-next, .swiper-button-prev')) return;
    if (e.target.closest('video, iframe')) return;
    const videoElement = card.videoElement || q(card, 'video-element');
    if (!videoElement) return;
    hydrateIfNeeded(videoElement);
    const isPlaying = card.dataset.playing === 'true';
    if (isPlaying) {
      pauseMedia(videoElement);
      card.dataset.playing = 'false';
      card.classList.remove('is-playing');
    } else {
      playMedia(videoElement);
      card.dataset.playing = 'true';
      card.classList.add('is-playing');
    }
  }, { passive: true });

  neutralizeHoverRuntime();
})();
